import { render } from "./caissedashboard.vue?vue&type=template&id=b9371448"
import script from "./caissedashboard.vue?vue&type=script&lang=js"
export * from "./caissedashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__